// Pure HTTP communication - no business logic
import {AxiosResponse} from "axios";

import CoreApi from "@/src/modules/core/api";

import {Me} from "../types";

class MeApi extends CoreApi {
  async get(): Promise<AxiosResponse<Me>> {
    return super.get("me");
  }
}

export const meApi = new MeApi();
